module.exports = __webpack_public_path__ + "img/rule_decoration_1.9cb0d356.png";